"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUnreachableError = exports.VerificationCodeExpired = exports.InvalidVerificationCodeError = exports.VerificationCodeError = exports.InvalidEmailAddressError = exports.DuplicateEmailOnSignUpError = exports.InvalidCredentialsError = exports.ValidationError = exports.UnauthorizedError = exports.ForbiddenError = exports.NotFoundError = void 0;
/**
 * not found error class
 */
class NotFoundError extends Error {
    /**
     * constructor
     *
     * @param {string} m
     */
    constructor(m = "Not found") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
exports.NotFoundError = NotFoundError;
/**
 * forbidden error class
 */
class ForbiddenError extends Error {
    /**
     * constructor
     *
     * @param {string} m
     */
    constructor(m = "Forbidden") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}
exports.ForbiddenError = ForbiddenError;
/**
 * unauthorized error class
 */
class UnauthorizedError extends Error {
    /**
     * constructor
     *
     * @param {string} m
     */
    constructor(m = "Unauthorized") {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}
exports.UnauthorizedError = UnauthorizedError;
class ValidationError extends Error {
    constructor(error) {
        super(error);
        this.errorMessage = error;
        // set the prototype explicitly.
        Object.setPrototypeOf(this, ValidationError.prototype);
    }
}
exports.ValidationError = ValidationError;
class InvalidCredentialsError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "InvalidCredentialsError";
        Object.setPrototypeOf(this, InvalidCredentialsError.prototype);
    }
}
exports.InvalidCredentialsError = InvalidCredentialsError;
class DuplicateEmailOnSignUpError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "DuplicateEmailOnSignUpError";
        Object.setPrototypeOf(this, DuplicateEmailOnSignUpError.prototype);
    }
}
exports.DuplicateEmailOnSignUpError = DuplicateEmailOnSignUpError;
class InvalidEmailAddressError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "InvalidEmailAddressError";
        Object.setPrototypeOf(this, InvalidEmailAddressError.prototype);
    }
}
exports.InvalidEmailAddressError = InvalidEmailAddressError;
class VerificationCodeError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "VerificationCodeError";
        Object.setPrototypeOf(this, VerificationCodeError.prototype);
    }
}
exports.VerificationCodeError = VerificationCodeError;
class InvalidVerificationCodeError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "InvalidVerificationCodeError";
        Object.setPrototypeOf(this, InvalidVerificationCodeError.prototype);
    }
}
exports.InvalidVerificationCodeError = InvalidVerificationCodeError;
class VerificationCodeExpired extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "VerificationCodeExpired";
        Object.setPrototypeOf(this, VerificationCodeExpired.prototype);
    }
}
exports.VerificationCodeExpired = VerificationCodeExpired;
class ApiUnreachableError extends Error {
    constructor(error) {
        super(error);
        // set the prototype explicitly.
        this.name = "ApiUnreachableError";
        Object.setPrototypeOf(this, ApiUnreachableError.prototype);
    }
}
exports.ApiUnreachableError = ApiUnreachableError;
//# sourceMappingURL=errorTypes.js.map